import { Component, Input, OnInit } from '@angular/core';

export interface IPriceTagData {
    currencyCode?: string;
    offerTitle?: string;
    discountLabel?: string;
    savePrefix?: string;
    saveSuffix?: string;
    regularPrice?: number | string;
    promoPrice?: number | string;
}

@Component({
    selector: 'price-tag',
    templateUrl: './price-tag.component.html',
    styleUrls: ['./price-tag.component.scss'],
})
export class PriceTagComponent implements OnInit {
    @Input() data: IPriceTagData;
    @Input() currencyCode: string = 'USD';
    @Input() offerTitle: string = 'Special Unlock Price';
    @Input() discountLabel: string = 'OFF';
    @Input() savePrefix: string = 'Save';
    @Input() saveSuffix: string = 'today';
    @Input() regularPrice: number | string = 22.99;
    @Input() promoPrice: number | string = 14.99;

    ngOnInit() {
        if (!this.data) {
            return;
        }
        if (this.data.currencyCode != null) {
            this.currencyCode = this.data.currencyCode;
        }
        if (this.data.offerTitle != null) {
            this.offerTitle = this.data.offerTitle;
        }
        if (this.data.discountLabel != null) {
            this.discountLabel = this.data.discountLabel;
        }
        if (this.data.savePrefix != null) {
            this.savePrefix = this.data.savePrefix;
        }
        if (this.data.saveSuffix != null) {
            this.saveSuffix = this.data.saveSuffix;
        }
        if (this.data.regularPrice != null) {
            this.regularPrice = this.data.regularPrice;
        }
        if (this.data.promoPrice != null) {
            this.promoPrice = this.data.promoPrice;
        }
    }

    private parsePrice(value: number | string): number {
        if (typeof value === 'number') {
            return value;
        }
        const parsed = parseFloat(value as string);
        if (Number.isFinite(parsed)) {
            return parsed;
        }
        return 0;
    }

    formatPrice(value: number | string): string {
        const parsed = this.parsePrice(value);
        return parsed.toFixed(2);
    }

    formatPriceWithCurrency(value: number | string): string {
        return `${this.formatPrice(value)} ${this.currencyCode}`;
    }

    getDiscountPercent(): number {
        const regular = this.parsePrice(this.regularPrice);
        const promo = this.parsePrice(this.promoPrice);
        if (!(regular > 0) || !(promo >= 0) || promo >= regular) {
            return 0;
        }
        return Math.round(((regular - promo) / regular) * 100);
    }

    getSavings(): string {
        const regular = this.parsePrice(this.regularPrice);
        const promo = this.parsePrice(this.promoPrice);
        const savings = regular - promo;
        if (savings <= 0) {
            return `0.00 ${this.currencyCode}`;
        }
        return `${savings.toFixed(2)} ${this.currencyCode}`;
    }

}
